import get from 'lodash/get'
import startsWith from 'lodash/startsWith'
import {createSelector} from 'reselect'

import {ShowroomTypes} from './enum'
import * as routerSelectors from './router'
import * as URLS from '../urls'

const nearestShowrooms = (state) => get(state, 'nearestShowrooms')

/**
 * @returns {Object[]}
 */
export const nearestTheBlackTuxShowrooms = createSelector(nearestShowrooms, ($nearestShowrooms) =>
  $nearestShowrooms.showrooms.filter(({type}) => type === ShowroomTypes.theBlackTux),
)

/**
 * @returns {Object[]}
 */
export const nearestNordstromShowrooms = createSelector(nearestShowrooms, ($nearestShowrooms) =>
  $nearestShowrooms.showrooms.filter(({type}) => type === ShowroomTypes.nordstrom),
)

/**
 * Returns the nearest The Black Tux or Nordstrom showroom
 *
 * @returns {Object|undefined} Location object or undefined if none
 */
export const nearestTheBlackTuxOrNordstromShowroom = createSelector(
  nearestShowrooms,
  ($nearestShowrooms) =>
    $nearestShowrooms.showrooms.filter(({type}) =>
      [ShowroomTypes.theBlackTux, ShowroomTypes.nordstrom].includes(type),
    )[0],
)

/**
 * Returns the nearest showroom under the following conditions:
 *   1.) Return TBT/Nordstrom location if a location is found within 25 miles
 *   2.) Return closest showroom found within 50 miles, if no TBT/Nordstrom location within 25 miles found
 *
 * @returns {Object|undefined} Location object
 */
export const nearestShowroom = createSelector(
  nearestTheBlackTuxOrNordstromShowroom,
  nearestShowrooms,
  ($nearestTheBlackTuxOrNordstromShowroom, $nearestShowrooms) => {
    if (
      $nearestTheBlackTuxOrNordstromShowroom &&
      $nearestTheBlackTuxOrNordstromShowroom.distanceInMiles <= 25
    ) {
      return $nearestTheBlackTuxOrNordstromShowroom
    }
    return $nearestShowrooms.showrooms.filter(({distanceInMiles}) => distanceInMiles <= 50)[0]
  },
)

export const shouldDisplayNearestShowroomBanner = createSelector(
  routerSelectors.pathname,
  nearestTheBlackTuxOrNordstromShowroom,
  (pathname, showroom) => {
    const urlsToHideBanner = [
      URLS.ACCOUNT,
      URLS.CHECKOUT,
      URLS.EVENT,
      URLS.FIT,
      URLS.LOOKBUILDER,
      URLS.ONBOARDING,
      URLS.RECEIPT,
      URLS.SHOWROOMS,
    ]
    return showroom && urlsToHideBanner.filter((url) => startsWith(pathname, url)).length <= 0
  },
)
